import { hideContextMenu } from "../../aplUtils/jqueryHelper";
import { ActivityType } from "../../types/activityType";
import { WorkOrderManagementButtonsProps } from "../../types/workorderManagementButtonsProps";
import { useTranslation } from "react-i18next";

export default function WorkorderManagementDefaultRightClick(props: WorkOrderManagementButtonsProps) {
    const { t } = useTranslation();
    if (
        !props.options.offlineLabl &&
        !props.options.offlineCons &&
        !props.options.assignLabl &&
        !props.options.assignCons &&
        !props.options.manageWorkorder
    )
        return <div id="contextMenu" className="ui-front"></div>;
    else
        return (
            <div id="contextMenu" className="ui-front" onClick={hideContextMenu}>
                <ul
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="dropdownMenu"
                    style={{ display: "block", position: "static", marginBottom: "5px" }}
                >
                    {props.options.offlineLabl ? (
                        <li>
                            <div
                                id="dropdownMenuOfflinePrint"
                                className={`dropdown-item ${!props.options.offlineLabl ? "disabled" : ""}`}
                                onClick={props.options.offlineLablClick}
                            >
                                {t("main.offlinePrint")!}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.offlineCons ? (
                        <li>
                            <div
                                id="dropdownMenuOfflineCons"
                                className={`dropdown-item ${!props.options.offlineCons ? "disabled" : ""}`}
                                onClick={props.options.offlineConsClick}
                            >
                                {t("main.offlineCons")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.assignLabl &&
                    (props.options.activityType === ActivityType.Labelling || props.options.activityType === ActivityType.Unspecified) ? (
                        <li>
                            <div
                                id="dropdownMenuAssignLabelling"
                                className={`dropdown-item ${!props.options.assignLabl ? "disabled" : ""}`}
                                onClick={props.options.assignLablClick}
                            >
                                {t("main.assign")! + " " + t("main.labels")!}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.assignCons &&
                    (props.options.activityType === ActivityType.Consumption || props.options.activityType === ActivityType.Unspecified) ? (
                        <li>
                            <div
                                id="dropdownMenuAssignConsumption"
                                className={`dropdown-item ${!props.options.assignCons ? "disabled" : ""}`}
                                onClick={props.options.assignConsClick}
                            >
                                {t("main.assign")! + " " + t("main.rxg_Consumption")!}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.manageWorkorder ? (
                        <li>
                            <div
                                id="dropdownMenuManageWorkorder"
                                className={`dropdown-item ${!props.options.manageWorkorder ? "disabled" : ""}`}
                                onClick={props.options.manageWorkorderClick}
                            >
                                {t("main.btnWoMan")!}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                </ul>
            </div>
        );
}
